export const REQUEST_PAYMENT_INTENT = '@OXD/REQUEST_PAYMENT_INTENT'
export const RECEIVE_PAYMENT_INTENT = '@OXD/RECEIVE_PAYMENT_INTENT'
export const ERROR_PAYMENT_INTENT = '@OXD/ERROR_PAYMENT_INTENT'
